import { ComponentType } from 'react'
import { Game, GameState } from 'types'
import { formattedTime } from 'shared/timeHelper'
import { motion } from 'framer-motion'

const AnimatedScore = ({
  score,
  hasChanged
}: {
  score: number | null
  hasChanged: boolean
}) => (
  <motion.span
    animate={hasChanged ? { scale: [1, 1.5, 1] } : { scale: 1 }}
    transition={{ duration: 0.5 }}
  >
    {score}
  </motion.span>
)
export const ScoreBox: ComponentType<{
  game: Game
  className?: string
  homeScoreChanged?: boolean
  awayScoreChanged?: boolean
}> = ({
  game: { showTime, awayGoals, homeGoals, state, startsAt },
  className,
  homeScoreChanged = false,
  awayScoreChanged = false
}) => {
    switch (state) {
      case GameState.PRE:
        return (
          <div
            className={`px-2 pt-1 bg-gray-200 rounded-sm flex flex-col justify-center items-center ${className || ''
              }`}
          >
            {showTime && (
              <>
                <div className="text-gray-800">{formattedTime(startsAt)}</div>
                <div className="-mt-0.5 uppercase text-xs text-gray-700 text-center font-semibold">
                  Uhr
                </div>
              </>
            )}
            {!showTime && (
              <div className="text-gray-800">{'- : -'}</div>
            )}
          </div>
        )

      case GameState.LIVE:
        return (
          <div
            className={`bg-primary text-white rounded-sm py-2 font-bold text-center flex justify-center items-center space-x-1 ${className || ''
              }`}
          >
            <AnimatedScore score={homeGoals} hasChanged={homeScoreChanged} />
            <span>:</span>
            <AnimatedScore score={awayGoals} hasChanged={awayScoreChanged} />
          </div>
        )
      case GameState.POST:
        return (
          <div
            className={`bg-black text-white rounded-sm py-2 font-bold text-center flex justify-center items-center space-x-1 ${className || ''
              }`}
          >
            <AnimatedScore score={homeGoals} hasChanged={homeScoreChanged} />
            <span>:</span>
            <AnimatedScore score={awayGoals} hasChanged={awayScoreChanged} />
          </div>
        )
      case GameState.POSTPONED:
        return (
          <div
            className={`p-2 bg-gray-200 rounded-sm text-center ${className || ''
              }`}
          >
            ver.
          </div>
        )
      case GameState.CANCELED:
        return (
          <div
            className={`p-2 bg-gray-200 rounded-sm text-center ${className || ''
              }`}
          >
            abg.
          </div>
        )
    }
  }
